export default __webpack_public_path__ + "static/media/login-background.1cd41047.png";